import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import CssMode from './CSSMode';
import HtmlMode from './HTMLMode';
import JavascriptMode from './JavascriptMode';
import JavaMode from './Java';

const ACEEditorContain = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs title='ACE Code Editor' parent='Editors' pageTitle='ACE Codes Editor' />
      <Row>
        <JavascriptMode />
        <HtmlMode />
        <CssMode />
        <JavaMode />
      </Row>
    </Container>
  );
};
export default ACEEditorContain;
